var map = {
	"./frontend/1x2FB.vue": 7259,
	"./frontend/2d3dPage.vue": 8623,
	"./frontend/AndroidGuide.vue": 594,
	"./frontend/BetslipHistory.vue": 4352,
	"./frontend/BodyFB.vue": 3301,
	"./frontend/CardGamePage.vue": 6499,
	"./frontend/ContactUs.vue": 3824,
	"./frontend/CorrectScore.vue": 4881,
	"./frontend/DataTable.vue": 818,
	"./frontend/Deposit.vue": 302,
	"./frontend/FishingPage.vue": 3965,
	"./frontend/FootballPage.vue": 7702,
	"./frontend/History.vue": 4737,
	"./frontend/Home.vue": 6962,
	"./frontend/IOSGuide.vue": 9210,
	"./frontend/Index.vue": 4815,
	"./frontend/Live.vue": 9407,
	"./frontend/LiveScore.vue": 5634,
	"./frontend/MainMenu.vue": 7015,
	"./frontend/MaungFB.vue": 9556,
	"./frontend/Setting.vue": 1347,
	"./frontend/SlotPage.vue": 8028,
	"./frontend/VideoLink.vue": 1463,
	"./frontend/Withdraw.vue": 8138,
	"./frontend/auth/Login.vue": 7901,
	"./frontend/auth/Register.vue": 5950,
	"./frontend/auth/Registerss.vue": 2601,
	"./frontend/auth/Rule.vue": 1389,
	"./frontend/auth/Verify.vue": 5590,
	"./frontend/components/AccountSelect.vue": 6233,
	"./frontend/components/CorrectScoreCard.vue": 6823,
	"./frontend/components/DataTable.vue": 7555,
	"./frontend/components/FBPreviewVoucher.vue": 9111,
	"./frontend/components/FBVoucher.vue": 570,
	"./frontend/components/FootballTeamCard.vue": 6659,
	"./frontend/components/GroupBox.vue": 7435,
	"./frontend/components/InputSelectDrawModal.vue": 2865,
	"./frontend/components/NormalBox.vue": 6251,
	"./frontend/components/PreviewVoucher.vue": 7037,
	"./frontend/components/RealCorrectScore.vue": 3922,
	"./frontend/components/SideNav.vue": 1604,
	"./frontend/components/Table.vue": 9134,
	"./frontend/components/ThreedGroupBox.vue": 5327,
	"./frontend/components/TwoDSelect.vue": 4692,
	"./frontend/components/Voucher.vue": 6593,
	"./frontend/normal-user/2d/2d.vue": 1641,
	"./frontend/normal-user/2d/ClosedDays.vue": 338,
	"./frontend/normal-user/2d/Home.vue": 9231,
	"./frontend/normal-user/2d/Winner.vue": 7405,
	"./frontend/normal-user/3d/3d.vue": 286,
	"./frontend/normal-user/3d/Home.vue": 5168,
	"./frontend/normal-user/DreamBooks.vue": 6611,
	"./frontend/normal-user/Index.vue": 5531,
	"./frontend/normal-user/bugyee/Room.vue": 8636,
	"./frontend/normal-user/game/Card.vue": 2884,
	"./frontend/normal-user/game/Fishing.vue": 8227,
	"./frontend/normal-user/game/Game.vue": 9621,
	"./frontend/normal-user/game/Slot.vue": 5264,
	"./frontend/normal-user/shankomee/Room.vue": 4199
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7057;